import { createSlice } from '@reduxjs/toolkit';

import axios from 'utils/axios';

const initialState = {
    error: null,
    categoryList: null,
    postList: null,
    postCount: null
};

const slice = createSlice({
    name: 'postList',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        setCategoryList(state, action) {
            state.categoryList = action.payload;
        },
        setPostListInfo(state, action) {
            state.postList = action.payload.posts;
            state.postCount = action.payload.count;
        },
        reset(state, action) {
            state.error = null;
            state.categoryList = null;
            state.postList = null;
            state.postCount = null;
        }
    }
});

export default slice.reducer;

export function getCategories(data, callback) {
    return async (dispatch) => {
        try {
            const response = await axios.get(`/api/category/list/public`, {});
            dispatch(slice.actions.setCategoryList(response.data.categories));
            if (callback) {
                callback();
            }
            return response.data.categories;
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            throw e;
        }
    };
}

export function getPostList(data, callback) {
    return async (dispatch) => {
        try {
            const response = await axios.get(`/api/post/list/${data.categoryId}/${data.page}`, {});
            dispatch(slice.actions.setPostListInfo(response.data));
            if (callback) {
                callback();
            }
            return response.data;
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            throw e;
        }
    };
}

export function clearStore(data, callback) {
    return (dispatch) => {
        dispatch(slice.actions.reset());
        if (callback) {
            callback();
        }
    };
}
